/* eslint-disable no-useless-escape */
import styles from "../../../_common/CrudFormStyles.module.scss";
import { useEffect } from "react";
import { Form, Input, Row, Col, Badge, DatePicker, Divider, Switch } from "antd";
import { translateKey as t } from "../../../../../locales/translation";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ClientsController } from "../../ClientsController";
import { observer } from "mobx-react";

const CustomFieldsTab = observer(({ controller, form }: { controller: ClientsController; form: any }) => {
  useEffect(() => {}, []);

  const { selectedClient, isReadOnly, isSelectedReadOnly, formMode, formFieldsSize, showFieldsIcon } = controller;
  const { trackView, geofences } = selectedClient.customFields;
  return (
    <>
      {trackView && (
        <>
          <Divider orientation="left">{t("lblTrackView", "Track View")}</Divider>
          <Row className={styles.newRow} gutter={20} style={formFieldsSize === "small" && { marginTop: 0 }}>
            <Col span={12}>
              <Form.Item
                colon={false}
                label={
                  <Badge dot={!trackView.devicePanel.stopTab}>
                    <span className={styles.formTitle}>{t("lblStopTab", "Stop Tab")}</span>
                  </Badge>
                }
                name={["customFields", "trackView", "devicePanel", "stopTab"]}
                rules={[{ required: true, whitespace: true, message: t("lblStopTabIsRequired", "Stop Tab is required") }]}
              >
                <Input
                  // onChange={handleInputChange}
                  name="customFields.trackView.devicePanel.stopTab"
                  disabled={isReadOnly || isSelectedReadOnly || formMode === "edit"}
                  autoFocus={formMode === "create"}
                  maxLength={99}
                  prefix={showFieldsIcon && <FontAwesomeIcon icon={faLock} style={{ color: "rgba(0,0,0,.25)" }} />}
                  size={formFieldsSize}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                colon={false}
                label={
                  <Badge dot={!trackView.geofenceName}>
                    <span className={styles.formTitle}>{t("lblGeofenceName", "Geofence Name")}</span>
                  </Badge>
                }
                name={["customFields", "trackView", "geofenceName"]}
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    message: t("lblGeofenceNameIsRequired", "Geofence Name is required"),
                  },
                ]}
              >
                <Input
                  // onChange={handleInputChange}
                  name="customFields.trackView.geofenceName"
                  disabled={isReadOnly || isSelectedReadOnly || formMode === "edit"}
                  autoFocus={formMode === "create"}
                  maxLength={99}
                  prefix={showFieldsIcon && <FontAwesomeIcon icon={faLock} style={{ color: "rgba(0,0,0,.25)" }} />}
                  size={formFieldsSize}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={20} className={styles.newRow} style={formFieldsSize === "small" && { marginTop: 0 }}>
            <Col span={6}>
              <Form.Item
                name={["customFields", "trackView", "showNotes"]}
                label="Show Notes"
                // valuePropName="jobDataImport.active"
              >
                <Switch disabled />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={["customFields", "trackView", "showOpenInGeofenceEditor"]}
                label="Show Open In Geofence Editor"
                // valuePropName="readFromSFTP"
              >
                <Switch disabled />
              </Form.Item>
            </Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
          </Row>
        </>
      )}
      {geofences && (
        <>
          <Divider orientation="left">{t("lblRouteTemplateEnabled", "Route Template Enabled")}</Divider>
          <Row gutter={20} className={styles.newRow} style={formFieldsSize === "small" && { marginTop: 0 }}>
            <Col span={6}>
              <Form.Item
                name={["customFields", "geofences", "routeTemplateEnabled"]}
                label="Active"

                // valuePropName="customFields.geofences.routeTemplateEnabled"
              >
                <Switch disabled />
              </Form.Item>
            </Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
          </Row>
        </>
      )}
    </>
  );
});

export default CustomFieldsTab;
